import { inject, Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { StorageHandlerService } from "../services";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  private readonly router = inject(Router);
  private readonly storageHandlerService = inject(StorageHandlerService);

  constructor() {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const checkUser = this.storageHandlerService.getItem("token");
    if (!checkUser) {
      this.router.navigate(["/login"]);
      return false;
    }
    return true;
  }
}
